export const environment = {
  server_url: 'https://kompakkt.de/server/',
  repo_url: 'https://kompakkt.de/',
};
